<template>
    <div class="home_box">
        <div class="carousel">
            <el-carousel trigger="click" :height="bannerHeight" arrow="never">>
                <el-carousel-item>
                    <img src="../assets/image/OIP-C.jpg" class="bannerimg">
                </el-carousel-item>
                <el-carousel-item>
                    <img src="../assets/image/OIP-C.jpg" class="bannerimg">
                </el-carousel-item>
                <el-carousel-item>
                    <img src="../assets/image/OIP-C.jpg" class="bannerimg">
                </el-carousel-item>
            </el-carousel>
            <!-- <div class="login">
                <div class="login_tit">代理商登录</div>
                <input class="input"  placeholder="请输入账号" type="text">
                <input class="input"  placeholder="请输入密码" type="password">
                <div class="vfcode">
                    <input class="input"  placeholder="请输入验证码" type="text">
                    <div class="code"></div>
                </div>
                <div class="login_btn">立即登录</div>
                <div class="protocol">
                    登录即代表同意<span style="color:#FDC33A;cursor: pointer;">用户协议</span>和<span style="color:#FDC33A;cursor: pointer;">隐私条款</span>
                </div>
            </div> -->
        </div>
        <div class="features_box">
            <div class="top_title">
                <div class="title_h1">主营业务</div>
                <div class="title_desc">多年APP、软件开发与行业经验的沉淀，覆盖数十种主流行业，对焦主流、热门的行业。<br>
全国6000家企业客户、3000万用户正在使用，专业的开发团队，只为制作出让客户满意，经得起考验的产品</div>
            </div>
            <div class="list_box">
                <div class="list_item">
                    通信系统
                </div>
                <div class="list_item">
                    计算机系统
                </div>
                <div class="list_item">
                    建筑智能化系统
                </div>
                <div class="list_item">
                    技术开发系统
                </div>
                <div class="list_item">
                    短视频系统
                </div>
                <div class="list_item">
                    钱包系统
                </div>
                <div class="list_item">
                    直播带货系统
                </div>
                <div class="list_item">
                    微信小程序
                </div>
                <div class="list_item">
                    餐饮外卖
                </div>
                <div class="list_item">
                    教育培训
                </div>
            </div>
        </div>
        <div class="advantage_box">
            <img class="advantage_bg" src="../assets/image/bg2.png" alt="">
            <div class="advantage">
                <!-- <img class="advantage_pt1" src="../assets/image/pt1.png" alt=""> -->
                <div class="advantage_pt1">我们的优势</div>
                <div class="yoush_box">
                    <!-- <div class="advantage_pt2">
                        <img style="width:100%" src="../assets/image/pt2.png" alt="">
                    </div>
                    <div class="advantage_pt3">
                        <img style="width:100%" src="../assets/image/pt3.png" alt="">
                    </div> -->
                    <div class="advantage_desc">
                        18年网站建设服务经验,    

                        服务27家世界500强企业,

                        服务136家上市企业,

                        服务行业龙头超过70家,

                        多项互联网传播大奖,

                        互联网创意策划专家,

                        经验丰富的软件开发团队,

                        完备的项目流程管理体系,

                        B2C营销型网站建设供应商,

                        系统研发与互联网技术并重.
                    </div>
                </div>
            </div>
        </div>
        <div class="technology_box">
            <div class="technology_left">
                <div class="technology_js1">
                    <!-- <img style="width:100%;" src="../assets/image/js1.png" alt=""> -->
                    我们的不同
                </div>
                <div class="technology_js2">西安欣联数据信息服务有限公司的互联网解决方案结合了十八年的互联网品牌设计经验和整合营销的理念，并将软件开发技术和传播技术紧密结合，我们不只是关注设计视觉个性的建立，我们还通过创意策划使得我们的设计让软件原本零碎分布的片段更好的整合起来，欣联数据的“创意+整合+营销”帮助客户插上互联网的翅膀！</div>
                <!-- <div class="technology_js2">
                    <img style="width:100%;" src="../assets/image/js2.png" alt="">
                </div>
                <div class="technology_desc">
                    (自主研发？)、稳定性强、运行流畅、用户体验舒适
                </div>
                <div class="technology_js3">
                    <img style="width:100%;" src="../assets/image/js3.png" alt="">
                </div>
                <div class="technology_desc">
                    独家定制服务，根据用户需求从页面到功能皆可DIY；后台、用户服务根据地区差异性开展特色服务
                </div>
                <div class="technology_js4">
                    <img style="width:100%;" src="../assets/image/js4.png" alt="">
                </div>
                <div class="technology_desc">
                    微信小程序、QQ小程序、学校管理端、供货商端、平台后台等多个端口；操作简单易上手、功能时尚且新潮、符合大学生需求品味
                </div> -->
            </div>
            <div class="technology_right">
                <div class="round_box">
                    <div class="round_logo">
                        <img class="round_img" src="../assets/image/bottomlogo.png" alt="">
                    </div>
                    <div class="round1">
                        <div class="round1_desc" style="font-size: 36px;">18+</div>
                        <div class="round1_desc">年经验</div>
                    </div>
                    <div class="round2">
                        <div class="round1_desc" style="font-size: 36px;">100%</div>
                        <div class="round1_desc">客户满意度</div>
                    </div>
                    <div class="round3">
                        <div class="round1_desc" style="font-size: 36px;">6,000+</div>
                        <div class="round1_desc">客户</div>
                    </div>
                    <div class="round4">
                        <div class="round1_desc" style="font-size: 36px;">3,000+</div>
                        <div class="round1_desc">项目</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cooperate_box">
            <img class="img_top" src="../assets/image/ShapeTop.png" alt="">
            <img class="img_bottom" src="../assets/image/ShapeBottom.png" alt="">
            <div class="cooperate_title">
                合作优势
            </div>
            <div class="cooperate_list">
                <div class="cooperate_item status">
                    <div class="item_img1">
                        <!-- <img style="width:100%;" src="../assets/image/hzs2.png" alt=""> -->
                        友创学院
                    </div>
                    <div class="item_desc">
                        一对一系统培训、手把手带你上车，保证你畅通运作
                    </div>
                </div>
                 <div class="cooperate_item">
                    <div class="item_img2">
                        运营体系完整（可行性）
                    </div>
                    <div class="item_desc">
                        市场前端、内容管理、后台服务拥有完整多元的运营体系
                    </div>
                </div>
                 <div class="cooperate_item">
                    <div class="item_img3">
                        <!-- <img style="width:100%;" src="../assets/image/hzs4.png" alt=""> -->
                        迭代更新迅速
                    </div>
                    <div class="item_desc">
                        实时检测市场需求、反馈，迅速调整功能、板块、服务，即时响应市场变化保持“校园云”最新潮、最好玩、最舒适
                    </div>
                </div>
            </div>
            <div class="win_box">
                <div class="win_left">
                    <div class="left_title">品牌共赢</div>
                    <div class="left_desc">
                        与各功能、各版块、国际国内大、小品牌建立互销平台，线上线下流量互动、快速引流、合作共赢！
                    </div>
                </div>
                <div class="win_right">
                    <!-- <img style="width:100%;" src="../assets/image/hzs5.png" alt=""> -->
                </div>
            </div>
        </div>
        <div class="process_box">
            <div class="process_tit">
                <div class="tit">
                    <!-- <div>校园云</div> -->
                    <div style="color:#333;">合作流程</div>
                </div>
                <!-- <div class="desc">COOPERATION PROCESS</div> -->
            </div>
            <div class="process_list">
                <div class="process_item">
                    <img class="item_img" src="../assets/image/hz1.png" alt="">
                    <div class="item_desc">前期沟通</div>
                </div>
                <img class="arrow" src="../assets/image/arrow.png" alt="">
                <div class="process_item">
                    <img class="item_img" src="../assets/image/hz2.png" alt="">
                    <div class="item_desc">实地考察</div>
                </div>
                <img class="arrow" src="../assets/image/arrow.png" alt="">
                <div class="process_item">
                    <img class="item_img" src="../assets/image/hz3.png" alt="">
                    <div class="item_desc">签订合同</div>
                </div>
                <img class="arrow" src="../assets/image/arrow.png" alt="">
                <div class="process_item">
                    <img class="item_img" src="../assets/image/hz4.png" alt="">
                    <div class="item_desc">缴纳费用</div>
                </div>
                <img class="arrow" src="../assets/image/arrow.png" alt="">
                <div class="process_item">
                    <img class="item_img" src="../assets/image/hz5.png" alt="">
                    <div class="item_desc">交付版本</div>
                </div>
                <img class="arrow" src="../assets/image/arrow.png" alt="">
                 <div class="process_item">
                    <img class="item_img" src="../assets/image/hz6.png" alt="">
                    <div class="item_desc">后台培训 运营培训</div>
                </div>
                <img class="arrow" src="../assets/image/arrow.png" alt="">
                <div class="process_item">
                    <img class="item_img" src="../assets/image/hz7.png" alt="">
                    <div class="item_desc">上线运营持续运营交流培训</div>
                </div>
            </div>
            <div class="join_box">
                <div class="welcome">
                    <div style="padding: 78px 0px 20px 0px">LOOKING FORWARD TO YOU</div>
                    <div style="border-bottom: 1px solid #fff;margin: 0 49px;"></div>
                    <div style="padding: 10px 0;font-size: 20px;letter-spacing:5px;">期待您的加入</div>
                    <div style="border-bottom: 1px solid #fff;margin: 0 49px;"></div>
                    <!-- <div style="padding: 10px 0;font-size: 16px;letter-spacing:5px;">致力于大学生创业服务平台</div> -->
                </div>
                <div class="form">
                    <div class="form_list">
                        <div class="form_item">
                            <div class="item_tit">
                                <div>您的姓名</div>
                                <div style="color:#FF0000;"> *</div>
                            </div>
                            <input class="item_input" type="text">
                        </div>
                        <div class="form_item">
                            <div class="item_tit">
                                <div>联系方式</div>
                                <div style="color:#FF0000;"> *</div>
                            </div>
                            <input class="item_input" type="text">
                        </div>
                    </div>
                    <div class="form_list">
                        <div class="form_item">
                            <div class="item_tit">
                                <div>所在地区</div>
                                <div style="color:#FF0000;"> *</div>
                            </div>
                            <input class="item_input" type="text">
                        </div>
                        <div class="form_item">
                            <div class="item_tit">
                                <div>您的要求</div>
                                <div style="color:#FF0000;"> *</div>
                            </div>
                            <input class="item_input" type="text">
                        </div>
                    </div>
                    <div class="form_btn" @click="btnClick">
                        提交
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            bannerHeight:'',
            count:0,
        };
    },
    created() {

    },
    mounted() {
        window.addEventListener('resize', this.getHeight);
        this.getHeight()
    },
    methods: {
        getHeight (){
            this.bannerHeight = window.innerHeight - 171 + 'px'
        },
        btnClick() {
            alert('提交成功！')
        },
    }
};
</script>

<style scoped lang="less">
.home_box {
    .carousel {
        position: relative;
        // height: calc(100vh);
        .login {
            position: absolute;
            top: 224px;
            right: 260px;
            width: 359px;
            height: 409px;
            background: #FFFFFF;
            border-radius: 24px;
            z-index: 10;
            padding: 0 35px;
            .login_tit {
                font-size: 28px;
                font-weight: bold;
                color: #333333;
                text-align: center;
                margin-top: 48px;
                margin-bottom: 30px;
            }
            .vfcode {
                display: flex;
                justify-content: space-between;
                .code {
                    width: 102px;
                    height: 40px;
                    background: #F9F9F9;
                    border-radius: 8px;
                    margin-left: 8px;
                }
            }
            .login_btn {
                width: 100%;
                height: 48px;
                background: #3899B3;
                border-radius: 24px;
                font-size: 16px;
                font-weight: 500;
                color: #333333;
                line-height: 48px;
                text-align: center;
                cursor: pointer;
                margin-top: 10px;
            }
            .protocol {
                width: 100%;
                position: absolute;
                bottom: 0;
                left: 0;
                height: 38px;
                font-weight: 500;
                color: #ABABAB;
                line-height: 38px;
                background: #FFFCF6;
                border-radius: 0px 0px 24px 24px;
                text-align: center;
            }
            .input {
                border: none;
                width: 100%;
                height: 40px;
                background: #F9F9F9;
                border-radius: 8px;
                padding: 0 21px;
                box-sizing: border-box;
                outline:none;
                margin-bottom: 20px;
            }
        }
        .bannerimg {
            width: 100%;
            height: 100%;
        } 
    }
    .features_box {
        position: relative;
        width: 100%;
        height: calc(100vh);
        background-color: #fff;
        margin-top:60px;
        .top_title {
            text-align: center;
            .title_h1 {
                font-size: 32px;
                line-height: 56px;
                font-weight: bold;
            }
            .title_desc {
                font-size: 18px;
                line-height: 38px;
                color: #787878;
                margin-bottom: 40px;
            }
        }
        .list_box {
            max-width: 1400px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            margin: 0 14%;
            .list_item {
                width: 17.8%;
                height: 212px;
                line-height: 210px;
                text-align: center;
                margin: 0 1% 24px 1%;
                font-weight: 300;
                font-size: 26px;
                border: 1px solid #6ec9e2;
                border-radius: 5px;
                cursor: pointer;
                -webkit-transition: All 0.4s ease-in-out;
            }
            .list_item:hover {
                box-shadow: 1px 1px 12px 3px rgb(110 201 226 / 40%);
                -webkit-transform: translate(0,-6px);
            }
        }
    }
    .advantage_box {
        position: relative;
        width: 100%;
        height: calc(100vh);
        background-color: #fff;
        .advantage_bg {
            z-index: 1;
            width: 100%;
            height: 100%;
        }
        .advantage {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            // display: flex;
            // flex-wrap: wrap;
            // justify-content: flex-end;
            .advantage_pt1 {
                position: absolute;
                top: 120px;
                right: 260px;
                width: 680px;
                height: 109px;
                font-size: 55px;
                font-weight: bold;
                letter-spacing:10px;
            }
            .yoush_box {
                position: absolute;
                right: 260px;
                top: 320px;
                width: 702px;
                height: 304px;
                background: #FFFFFF;
                box-shadow: 0px 4px 58px 10px rgba(237, 237, 237, 0.08);
                border-radius: 24px;
                padding: 69px;
                .advantage_pt2 {
                    width: 203px;
                    height: 31px;
                }
                .advantage_pt3 {
                    width: 313px;
                    height: 21px;
                    margin-top: 82px;
                }
                .advantage_desc {
                    font-size: 16px;
                    font-weight: 500;
                    color: #595959;
                    margin-top: 34px;
                    line-height: 30px;
                    letter-spacing:3px;
                }
            }
        }

    }
    .technology_box {
        display: flex;
        justify-content: space-between;
        width: 100%;
        overflow: hidden;
        .technology_left {
            padding-left: 158px;
            padding-top: 130px;
            padding-bottom: 180px;
            .technology_js1 {
                // width: 203px;
                // height: 40px;
                font-size: 55px;
                font-weight: bold;
                letter-spacing: 10px;
                margin-bottom: 20px;
            }
            .technology_js2 {
                width: 530px;
                margin-top: 47px;
                font-size: 16px;
                letter-spacing:3px;
                color: #595959;
                line-height: 30px;
                text-align:justify; // 所有行两端对齐
                text-justify:inter-ideograph; // 最后一行居左对齐
            }
            .technology_js3 {
                width: 350px;
                margin-top: 47px;
            }
            .technology_js4 {
                width: 220px;
                margin-top: 47px;
            }
            .technology_desc {
                font-size: 14px;
                font-weight: 500;
                color: #595959;
                margin-top: 27px;
            }
        }
        .technology_right {
            padding-right: 94px;
            .round_box {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 575px;
                height: 575px;
                background: rgba(255, 255, 255, 0);
                border: 3px solid rgba(226, 226, 226, 0.27);
                border-radius: 50%;
                margin-top: -50px;
                .round_logo {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 287px;
                    height: 287px;
                    background: rgba(255, 255, 255, 0);
                    border: 1px solid #FFF7E4;
                    box-shadow: 3px 4px 59px 0px rgba(253, 195, 58, 0.1);
                    border-radius: 50%;
                    .round_img {
                        width: 138px;
                        height: 158px;
                    }
                }
                .round1,.round2,.round3,.round4 {
                    position: absolute;
                    width: 160px;
                    height: 160px;
                    box-shadow: 7px 11px 20px 0px rgba(117, 149, 223, 0.22);
                    border-radius: 50%;
                    box-sizing: border-box;
                    padding-top: 50px;
                    .round1_desc {
                        text-align: center;
                        color: #fff;
                        font-weight: 500;
                        font-size: 18px;
                    }
                }
                .round1 {
                    top: 50%;
                    transform: translateY(-50%);
                    left: -80px;
                    background: linear-gradient(43deg, #907DE4, #21DFD1);
                   
                }
                .round2 {
                    top: 50%;
                    transform: translateY(-50%);
                    right: -80px;
                    background: linear-gradient(43deg, #3BB5B6, #42E397);
                }
                .round3 {
                    bottom: -20px;
                    left: 50px;
                    background: linear-gradient(43deg, #EE727D, #FDA23F);
                }
                .round4 {
                    bottom: -20px;
                    right: 50px;
                    background: linear-gradient(43deg, #6EC9E2, #00D8FF);
                }
            }
        }
    }
    .cooperate_box {
        position: relative;
        width: 100%;
        height: calc(100vh);
        background: #FFF9EA;
        .img_bottom {
            width: 236px;
            height: 47px;
            position: absolute;
            top: -1px;
            left: 50%;
            transform: translateX(-50%);
        }
        .img_top {
            width: 236px;
            height: 47px;
            position: absolute;
            bottom: -1px;
            left: 50%;
            transform: translateX(-50%);
        }
        .cooperate_title {
            width: 100%;
            display: flex;
            justify-content: center;
            padding-top: 88px;
            font-size: 55px;
            font-weight: bold;
            letter-spacing:10px;
            
        }
        .cooperate_list {
            display: flex;
            justify-content: space-between;
            padding-top: 60px;
            padding-left: 158px;
            padding-right: 158px;
            .cooperate_item {
                width: 320px;
                height: 138px;
                background: #FFFFFF;
                border-radius: 12px;
                padding: 32px;
                // margin-left: 70px;
                .item_img1 {
                    // width: 200px;
                    font-size: 26px;
                    font-weight: 400px;
                    color: #00D8FF;
                }
                .item_img2 {
                    // width: 28px;
                    font-size: 26px;
                    font-weight: 400px;
                    color: #00D8FF;
                }
                .item_img3 {
                    // width: 180px;
                    font-size: 26px;
                    font-weight: 400px;
                    color: #00D8FF;
                }
                .item_desc {
                    font-size: 14px;
                    color: #595959;
                    line-height: 24px;
                    margin-top: 20px;
                }
            }
            .status {
                border-bottom: 3px solid #00D8FF;
            }
        }
        .win_box {
            display: flex;
            justify-content: space-between;
            padding-left: 258px;
            padding-right: 258px;
            padding-top: 50px;
            .win_left {
                padding-top: 75px;
                .left_title {
                    font-size: 32px;
                    font-weight: bold;
                    color: #3C2C06;
                }
                .left_desc {
                    width: 508px;
                    height: 49px;
                    font-size: 18px;
                    font-weight: 400;
                    color: #595959;
                    line-height: 30px;
                    margin-top: 16px;
                }
            }
            .win_right {
                width: 522px;
                height: 416px;
            }
        }
    }
    .process_box {
        width: 100%;
        height: calc(100vh + 220px);
        background: #fff;
        padding: 0 160px;
        box-sizing: border-box;
        .process_tit {
            padding-top: 100px;
            .tit {
                display: flex;
                letter-spacing:15px;
                font-size: 55px;
                font-weight: bold;
                // color: #3899B3;
            }
            .desc {
                font-size: 39px;
                font-family: Constantia;
                letter-spacing:15px;
                font-weight: bold;
                color: #666;
                margin-top: 20px;
            }
        }
        .process_list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-top: 111px;
            padding-bottom: 111px;
            .process_item {
                width: 122px;
                height: 122px;
                .item_img {
                    width: 122px;
                    height: 122px;
                }
                .item_desc {
                    font-size: 18px;
                    color: #2F2F2F;
                    text-align: center;
                    font-weight: 500;
                    line-height: 27px;
                    padding: 20px;
                }
            }
            .arrow {
                width: 42px;
                height: 22px;
            }
        }
        .join_box {
            display: flex;
            justify-content: center;
            padding-top: 200px;
            .welcome {
                width: 356px;
                height: 294px;
                background: #3899B3;
                text-align: center;
                font-size: 22px;
                font-weight: bold;
                color: #FFFFFF;
            }
            .form {
                width: 844px;
                height: 294px;
                background-color: #222;
                padding: 38px 50px;
                box-sizing: border-box;
                .form_list {
                    display: flex;
                    justify-content: space-between;
                    .item_tit {
                        display: flex;
                        align-items: baseline;
                        font-size: 14px;
                        font-weight: bold;
                        color: #FFFFFF;
                    }
                    .item_input {
                        border: none;
                        padding: 0 21px;
                        box-sizing: border-box;
                        outline:none;
                        margin-bottom: 20px;
                        width: 352px;
                        height: 37px;
                        background: #FFFFFF;
                        border: 1px solid #DEDEDE;
                        border-radius: 4px;
                        margin-top: 10px;
                    }
                }
                .form_btn {
                    width: 150px;
                    height: 37px;
                    background: #79635B;
                    border: 1px solid #DEDEDE;
                    border-radius: 4px;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #FFFFFF;
                    line-height: 37px;
                    text-align: center;
                    cursor: pointer;
                }
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue